import PumpPch from "../PumpPch/PumpPch";
import DiPch from '../DiPch/DiPch';
import { getPchInstartError } from '../../../Utils/ErrorPch'; //функция с ошибками частотников  getPchInstartError
import { getPchEsqError } from '../../../Utils/ErrorPch';
import { getPchAtvError } from '../../../Utils/ErrorPch';
import { checkBit, stateNA, formatParametr } from '../../../Utils/Functions';

export default function PrepDataPch({pchData}) {

  // Функция для подготовки данных Частотника
    const preparePumpData = (typeRsDevice) => {
        let pumpData = {};
        switch(typeRsDevice) {
            case 'PCH_Instart':
                pumpData.mode = pchData?.param8==='8' ? 'по ПИД' : (pchData?.param8==='9' ? ('по Скорости'):('...'));
                pumpData.status = ((pchData?.param12==='65535') || (pchData?.param12==='0')) ? (
                 stateNA(pchData?.param6)) : ('Авария');
                pumpData.speed = formatParametr(pchData?.param9, 2, 'Гц');
                pumpData.current = formatParametr(pchData?.param11, 1, 'А');
                pumpData.voltage = formatParametr(pchData?.param10, 1, 'В');
                
                // Определяем аварию ПЧ и получаем детали
                pumpData.driveFault = pchData?.param12!=='0';
                pumpData.faultDetails = getPchInstartError(pchData?.param12);

                break;
            case 'PCH_ESQ':
                pumpData.mode = pchData?.param8==='8' ? 'по ПИД' : (pchData?.param8==='9' ? ('по Скорости'):('...'));
                pumpData.status = stateNA(pchData?.param6);
                pumpData.speed = formatParametr(pchData?.param9, 2, 'Гц');
                pumpData.current = formatParametr(pchData?.param11, 1, 'А');
                pumpData.voltage = formatParametr(pchData?.param10, 1, 'В');

                 // Определяем аварию ПЧ и получаем детали
                 pumpData.driveFault =  pchData?.param12!=='0';
                 pumpData.faultDetails = getPchEsqError(pchData?.param12);
                break;

            case 'PCH_ATV':
                pumpData.mode = pchData?.param8==='1' ? 'по ПИД' : (pchData?.param8==='0' ? ('по Скорости'):('...'));
                if (checkBit(pchData?.param6, 1)) {pumpData.status='Готов'}
                else if(checkBit(pchData?.param6, 2)) {pumpData.status='В работе'}
                else if (checkBit(pchData?.param6, 3)) {pumpData.status='Авария'}
                pumpData.speed = formatParametr(pchData?.param9, 1, 'Гц');
                pumpData.current = formatParametr(pchData?.param11, 1, 'А');
                pumpData.voltage = formatParametr(pchData?.param10, 1, 'В');

                 // Определяем аварию ПЧ и получаем детали
                 pumpData.driveFault = pchData?.param12!=='0';
                 pumpData.faultDetails = getPchAtvError(pchData?.param12);
                break;

                default:
                    return null;
            }
            return pumpData;
    }
    // Подготавливаем данные для всех насосов
    const pump1Data = preparePumpData(pchData?.typeRsDevice_name);
    
    return (
        <> 
            {pump1Data && <PumpPch 
                mode={pump1Data.mode}
                status={pump1Data.status}
                speed={pump1Data.speed}
                current={pump1Data.current}
                voltage={pump1Data.voltage}
                driveFault={pump1Data.driveFault}
                faultDetails={pump1Data.faultDetails}
            />}
            {pump1Data && <DiPch stateDi={pchData?.param7} />}
        </>
    )
}